import { Box, CircularProgress, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RoleIdText } from "./Atom"
import { useResponseHandle } from "../../../../../../hooks"
import AdminAPI from "./../../../../../../../api/admin"
import { getTokenLocal } from "../../../../../../../helper/utils"
import { setAdvisorsData } from "../../../../../../redux/slices/usersSlice"
import { useNavigate } from "react-router-dom"

const adminAPI = new AdminAPI()

function AdvisorListTab({ group_sk }: any) {
  const token: any = getTokenLocal()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const allAdvisors = useSelector((state: any) => {
    return state.users.advisorsData
  })

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const fetchAllAdvisors = async () => {
    const response = await adminAPI.getAllAdvisors(token, group_sk)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      setIsLoading(false)
      if (result?.statusCode == 200) {
        dispatch(setAdvisorsData(result?.data))
      }
    } else {
      navigate("/auth")
    }

    return result
  }

  useEffect(() => {
    allAdvisors.length === 0 && setIsLoading(true)
    fetchAllAdvisors()
  }, [group_sk])

  return (
    <>
      {!isLoading ? (
        allAdvisors.length > 0 ? (
          <Box
            sx={{
              width: "30%",
              height: "100%",
              border: "1px solid #E3E3E3",
            }}
          >
            {allAdvisors?.map((advisor: any, itemIndex: any) => {
              return (
                <li
                  key={itemIndex}
                  style={{
                    listStyle: "none",
                    padding: "22px 20px",
                    fontSize: "14px",
                    color: "#000",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    borderBottom: "1px solid #E5E5E5",
                  }}
                >
                  {advisor?.name}
                  <RoleIdText>{advisor.role_display_name}</RoleIdText>
                </li>
              )
            })}
          </Box>
        ) : (
          <Typography sx={{ padding: "2rem" }}>
            No Group Admins assigned
          </Typography>
        )
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            // border: "1px solid red"
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  )
}

export default AdvisorListTab
